export default "__VITE_ASSET__WKZ2fzRT__"